/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getActivitiesAdapter } from '../../../adapters/get-activities.adapter';
import { URLS } from '../../../../../constants/urls.constants';
import { useApiRequest, IResponsePayload } from '../../../../../hooks/useApiRequest';
import { stopLoading } from '../../../../../store/modules/loading';
import { setAlert } from '../../../../../store/modules/snackbar';
import {
	IAdaptedActivities,
	IActivities,
} from '../../../interfaces/get-activities.interface';

export const useGetIndicators = () => {
	const dispatch = useDispatch();
	const [indicatorsOptions, setIndicatorsOptions] = useState<IAdaptedActivities[]>([]);

	const {
		execute: getIndicators,
		status: statusGetIndicators,
		value: valueGetIndicators,
	} = useApiRequest<unknown, IResponsePayload<IActivities>>({
		path: URLS.EDIT_PROJECT.CHRONOGRAM.GET_INDICATORS_BY_FUNCTIONAL,
		method: 'GET',
	});

	useEffect(() => {
		if (statusGetIndicators === 'success') {
			dispatch(stopLoading());
			setIndicatorsOptions(getActivitiesAdapter(valueGetIndicators?.data || []));
		} else if (statusGetIndicators === 'error') {
			dispatch(
				setAlert({
					show: true,
					message: 'Ocurrió un error al consultar la información',
					severity: 'error',
				})
			);
			dispatch(stopLoading());
		}
	}, [statusGetIndicators]);

	return {
		indicatorsOptions,
		getIndicators,
		setIndicatorsOptions,
	};
};
